import { injectLocal } from '@vueuse/core';
import { PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY } from '~/modules/product/constants/providers';

export default function useFeatureEligibility() {
  const data = injectLocal(PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY);

  if (typeof data === 'undefined') {
    throw new TypeError('useFeatureEligibility() is called without provider.');
  }

  return data;
}
